import * as APIRoutes from '@mm/api-routes';
import { EspDomainType } from '../model/EspModel';
import AuthenticatedController from './AuthenticatedController';

export default class CompanyController extends AuthenticatedController {
  static getDomains(pageId: number): Promise<{ domains: EspDomainType }> {
    return super.get(`${APIRoutes.ESP_DOMAINS}?facebook_page_id=${pageId}`);
  }

  static postDomain(args: {
    facebookPageId: number;
    domain: string;
  }): Promise<{ domain: EspDomainType }> {
    return super.post(`${APIRoutes.ESP_DOMAINS}`, args);
  }

  static validateDomain(domainId: number): Promise<{ domain: EspDomainType }> {
    return super.post(`${APIRoutes.ESP_DOMAIN_ID(domainId)}/validate`);
  }

  static destroyDomain(domainId: number) {
    return super.delete(`${APIRoutes.ESP_DOMAIN_ID(domainId)}`);
  }
}
